var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7412 14.1408C20.3071 15.9133 19.3455 17.5119 17.982 18.7247C16.336 20.1929 14.2056 21.0028 12 20.9997C9.79403 21.0031 7.66423 20.1931 6.018 18.7247C4.6545 17.5119 3.69188 15.9133 3.25782 14.1408C2.82375 12.3683 2.93874 10.5058 3.58753 8.80018C4.23633 7.09457 5.38827 5.62648 6.8906 4.5906C8.39293 3.55472 10.1747 3 11.9995 3C13.8243 3 15.6061 3.55472 17.1084 4.5906C18.6107 5.62648 19.7627 7.09457 20.4115 8.80018C21.0603 10.5058 21.1752 12.3683 20.7412 14.1408Z",
    fill: "#DFDFDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.964 18.7253C17.2653 17.8001 16.5381 16.7663 15.5 16.25C14.4619 15.7337 13.1414 15.7492 11.982 15.7503C10.8226 15.7492 9.53807 15.7337 8.5 16.25C7.46193 16.7663 6.69874 17.8001 6 18.7253M17.964 18.7253C16.318 20.1935 14.1876 21.0034 11.982 21.0003C9.77603 21.0036 7.64624 20.1937 6 18.7253",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.9997C16 12.0606 15.5786 13.078 14.8284 13.8281C14.0783 14.5783 13.0609 14.9997 12 14.9997C10.9391 14.9997 9.92172 14.5783 9.17157 13.8281C8.42142 13.078 8 12.0606 8 10.9997C8 9.93883 8.42142 8.92142 9.17157 8.17127C9.92172 7.42112 10.9391 6.9997 12 6.9997C13.0609 6.9997 14.0783 7.42112 14.8284 8.17127C15.5786 8.92142 16 9.93883 16 10.9997Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.9997C16 12.0606 15.5786 13.078 14.8284 13.8281C14.0783 14.5783 13.0609 14.9997 12 14.9997C10.9391 14.9997 9.92172 14.5783 9.17157 13.8281C8.42142 13.078 8 12.0606 8 10.9997C8 9.93883 8.42142 8.92142 9.17157 8.17127C9.92172 7.42112 10.9391 6.9997 12 6.9997C13.0609 6.9997 14.0783 7.42112 14.8284 8.17127C15.5786 8.92142 16 9.93883 16 10.9997Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.5bb4a436693a887e38c08ecb802e9384.svg";
export { ForwardRef as ReactComponent };